import { Clock3, Code2, FileText, Mail } from "lucide-react";

import { formatDate, formatMinutesDuration, formatOptionalDate } from "../formatters";

export default function TicketSummary({ ticket, userRole }) {
  return (
    <>
      <div className="support-ticket-meta">
        <span className="support-pill"><Clock3 className="w-4 h-4" />{ticket.status_label}</span>
        <span className="support-pill"><FileText className="w-4 h-4" />{ticket.category}</span>
        <span className="support-pill"><Mail className="w-4 h-4" />{ticket.client_email}</span>
        {userRole !== "client" && (
          <span className="support-pill">
            <Code2 className="w-4 h-4" />
            {ticket.assigned_developer_name || "Non attribue"}
          </span>
        )}
      </div>

      <div className="support-ticket-panel">
        <h3 className="heading-3">{ticket.title}</h3>
        <div className="support-read-tracker">
          <span>Cree le : {formatDate(ticket.created_at)}</span>
          {userRole === "admin" && (
            <>
              <span>Ouvert par le client : {formatOptionalDate(ticket.client_last_viewed_at)}</span>
              <span>Ouvert par l'admin : {formatOptionalDate(ticket.admin_last_viewed_at)}</span>
              <span>Ouvert par le developpeur : {formatOptionalDate(ticket.developer_last_viewed_at)}</span>
            </>
          )}
        </div>
        {userRole !== "client" && ticket.development_time_minutes !== null && ticket.development_time_minutes !== undefined && (
          <p className="body-small">
            Temps de developpement saisi: {formatMinutesDuration(ticket.development_time_minutes)}
            {ticket.development_time_updated_by ? ` par ${ticket.development_time_updated_by}` : ""}
          </p>
        )}
        {userRole !== "client" && ticket.client_tma_enabled && (
          <p className="body-small">
            TMA : {formatMinutesDuration(ticket.client_tma_minutes_used)} / {formatMinutesDuration(ticket.client_tma_minutes_total)}
            {" "}- Restant : {formatMinutesDuration(ticket.client_tma_minutes_remaining)}
          </p>
        )}
        <div
          className="support-rich-content body-medium"
          dangerouslySetInnerHTML={{ __html: ticket.description }}
        />
      </div>
    </>
  );
}
